// Dispatcher — renders the specialized row for the event's classification.

import { DataRow } from "./rows/DataRow";
import { EarningRow } from "./rows/EarningRow";
import { SpeakerRow } from "./rows/SpeakerRow";
import { SupplyRow } from "./rows/SupplyRow";
import type { CommonRowProps } from "./rowCommon";

export function CalendarRow(props: CommonRowProps) {
  switch (props.event.classification) {
    case "earning":
      return <EarningRow {...props} />;
    case "supply":
      return <SupplyRow {...props} />;
    case "speaker":
      return <SpeakerRow {...props} />;
    // data / ad_hoc / expiry / holiday / comment all fall through to DataRow.
    default:
      return <DataRow {...props} />;
  }
}

export default CalendarRow;
